module.exports = __webpack_public_path__ + "img/016.d89fb098.jpg";